// extracted by mini-css-extract-plugin
export var activeFilterButton = "_s6-c";
export var backButton = "_s6-4";
export var backIcon = "_s6-5";
export var chevronShortcut = "_s6-6";
export var container = "_s6-1";
export var editor = "_s6-8";
export var editorWrapper = "_s6-7";
export var prefix = "_s6-2";
export var searchIcon = "_s6-3";
export var suffix = "_s6-9";
export var suffixContent = "_s6-a";
export var suffixText = "_s6-b";
export var wrapper = "_s6-0";